import React, { useState, lazy, Suspense, useEffect } from "react";
import axios from "axios";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import { useHyperlink } from "./contexts/HyperlinkProvider";

import Logo from "./components/Logo Section/Logo";

import "@fontsource/poppins";

import "./App.css";

const Header = lazy(() => import("./components/Header.js"));
const Highlight = lazy(() => import("./components/Highlights.js"));
const Empathetic = lazy(() => import("./components/Empathetic.js"));
const Powered = lazy(() => import("./components/powered.js"));
const PressKit = lazy(() => import("./components/PressKit.js"));
const Footer = lazy(() => import("./components/Footer.js"));

function App() {
  const appVersion = appversion.version;
  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = process.env.REACT_APP_SWMC_ANALYTICS;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const [links, setLinks] = useState({ brandName: 'AngelAi', brandURL: 'https://www.angelai.com' });
  const [angelAiLink, setAngelAiLink] = useState('AngelAi');
  const [angelAiComLink, setAngelAiComLink] = useState('AngelAi.com');
  const [sunwestLink, setSunWestLink] = useState('Sun West');
  const [sunwestFullLink, setSunWestFullLink] = useState('Sun West Mortgage Company, Inc.');
  const [celligenceLink, setCelligenceLink] = useState('Celligence');
  const [celligenceLlcLink, setCelligenceLlcLink] = useState('Celligence LLC');
  const [pavanLink, setPavanLink] = useState('Pavan Agarwal');
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const aiLink = await getHyperLink('websites', 'angelai', 0);
      const aiComLink = await getHyperLink('websites', 'angelai', 1);
      const swLink = await getHyperLink('websites', 'swmc', 0);
      const swFullLink = await getHyperLink('websites', 'swmc', 1);
      const cellLink = await getHyperLink('websites', 'celligence', 1);
      const cellLlcLink = await getHyperLink('websites', 'celligence', 0);
      const pavan = await getHyperLink('profiles', 'pavan', 0);
      setAngelAiLink(aiLink || 'AngelAi');
      setAngelAiComLink(aiComLink || 'AngelAi.com');
      setSunWestLink(swLink || 'Sun West');
      setSunWestFullLink(swFullLink || 'Sun West Mortgage Company, Inc.');
      setCelligenceLink(cellLink || 'Celligence');
      setCelligenceLlcLink(cellLlcLink || 'Celligence LLC');
      setPavanLink(pavan || 'Pavan Agarwal');
    };
    processContent();
  }, [getHyperLink]);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data.current);
      } catch (error) {
        console.error("Error fetching links:", error);
      }
    };
    fetchLinks();
  }, []);
  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true}
      isVerboseMode={false}
      metaFileDirectory={"."}
    >
      <>
    
        <Suspense fallback={<div />}>
          <Header links={links} angelAiLink={angelAiLink} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Highlight links={links} angelAiLink={angelAiLink} sunwestLink={sunwestLink} sunwestFullLink={sunwestFullLink} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Empathetic links={links} angelAiLink={angelAiLink} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Powered links={links} angelAiLink={angelAiLink} angelAiComLink={angelAiComLink} />
        </Suspense>
        <Suspense fallback={<div />}>
          <PressKit links={links} angelAiLink={angelAiLink} celligenceLink={celligenceLink} celligenceLlcLink={celligenceLlcLink} sunwestFullLink={sunwestFullLink} pavanLink={pavanLink} />
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer angelAiLink={angelAiLink} celligenceLlcLink={celligenceLlcLink} sunwestFullLink={sunwestFullLink} />
        </Suspense>
        
      </>
    </CacheBuster>
  );
}

export default App;
